define( [
	"../Data"
], function( Data ) {
	"use strict";

	return new Data();
} );



/*****************
 ** WEBPACK FOOTER
 ** ./~/jquery/src/data/var/dataPriv.js
 ** module id = 46
 ** module chunks = 0
 **/